export default __webpack_public_path__ + "static/media/amba.482cb02d.jpg";